export const EVENT_TYPES = ["Hearing", "Trial", "CLE", "Deadline", "Firm Event", "Meeting"];
export const TYPE_COLOR = {
  Trial: "bg-primary text-primary-foreground",
  Hearing: "bg-blue-600 text-white",
  CLE: "bg-emerald-600 text-white",
  Deadline: "bg-amber-500 text-black",
  "Firm Event": "bg-purple-600 text-white",
  Meeting: "bg-slate-600 text-white",
};
export const BLANK_EVENT = { title: "", type: "Hearing", date: "", time: "", location: "", owner: "" };
